import React from 'react'
import styled from 'styled-components'
import { ThreeColumnSchoolList } from '../ThreeColumnSchoolList'
import { STYLES } from '../../static/style'
import { School } from '../props/School.types'

const StyledNearbySchoolsSection = styled.div``

const StyledSchoolDetailsSectionTitle = styled.div`
  font-weight: ${STYLES.FONT_WEIGHT_BOLD};
  font-size: ${STYLES.FONT_SIZE_LG};
  margin: 1rem 0;
`

interface INearbySchoolsSectionProps {
  schools: Array<School>
}

const NearbySchoolsSection: React.FC<INearbySchoolsSectionProps> = ({
  schools,
}) => (
  <StyledNearbySchoolsSection>
    <StyledSchoolDetailsSectionTitle>
      Nearby Schools
    </StyledSchoolDetailsSectionTitle>
    <ThreeColumnSchoolList schools={schools} />
  </StyledNearbySchoolsSection>
)

export { NearbySchoolsSection }
